import axios from 'axios'
import fetch from '@/utils/fetch'
// const apiConfig = require('../../static/config.json')
const fileLoadPath =window.Glob.BASE_URL;
const apiUrl = window.Glob.BASE_URL;

//系统设置

export function getSettings() {
  return fetch({
    url: apiUrl + '/api/Domain/GetSettings',
    method: 'post',
  })
}
export function updateSettings(data) {
  return fetch({
    url: apiUrl + '/api/Domain/UpdateSettings',
    method: 'post',
    data
  })
}

export function createDomain(data) {
    return fetch({
      url: apiUrl + '/api/Domain/CreateDomain',
      method: 'post',
      data,
      noToken:true
    })
  }

export function sendValidationCode(params){
    return fetch({
        url: apiUrl + '/api/Domain/SendValidationCode',
        method: 'POST',
        params,
        noToken:true
    });
}


// WEBPACK FOOTER //
// ./src/api/domainApi.js